import { FC } from 'react';

/** @deprecated */
const PeopleIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 9C19.5 10.38 18.381 11.5 17 11.5C15.617 11.5 14.5 10.38 14.5 9C14.5 7.619 15.617 6.5 17 6.5C18.381 6.5 19.5 7.619 19.5 9V9Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5 12C23.5 18.352 18.352 23.5 12 23.5C5.649 23.5 0.5 18.352 0.5 12C0.5 5.648 5.649 0.5 12 0.5C18.352 0.5 23.5 5.648 23.5 12V12Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="7.51 2.81"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 17.5C15.5 14.462 13.037 11.5 10 11.5C6.963 11.5 4.5 14.462 4.5 17.5H15.5V17.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 8C13.5 9.933 11.933 11.5 10 11.5C8.067 11.5 6.5 9.933 6.5 8C6.5 6.067 8.067 4.5 10 4.5C11.933 4.5 13.5 6.067 13.5 8V8Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1434 15.5H20.9994C20.9994 13.291 19.2084 11.5 16.9994 11.5C15.6484 11.5 14.4574 12.175 13.7344 13.202"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PeopleIcon;
